document.addEventListener("DOMContentLoaded", function () {
  // Function to check if an element is in the viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    console.log('Element bounds:', rect);  // Debugging to check element bounds
        console.log('Viewport height:', window.innerHeight);
        console.log('Viewport width:', window.innerWidth);
    const inViewport = (
        rect.top < window.innerHeight &&  // Element's top is above the bottom of the viewport
        rect.bottom > 0 &&                // Element's bottom is below the top of the viewport
        rect.left < window.innerWidth &&  // Element's left side is before the right side of the viewport
        rect.right > 0                    // Element's right side is after the left side of the viewport
    );

    return inViewport;
  }

  // Function to add animation classes when elements are in the viewport
  function checkAnimation() {
    const elements = document.querySelectorAll(
      ".fade-in, .slide-up, .zoom-in, .slide-up-slow, .slide-left-to-right, .slide-right-to-left"
    );
    elements.forEach((element) => {
      if (isInViewport(element)) {
        if (element.classList.contains("fade-in")) {
          element.style.transition = "opacity 1s ease-in-out";
          element.style.opacity = 1;
        } else if (element.classList.contains("slide-up")) {
          element.style.transition = "transform 1s ease, opacity 1s ease";
          element.style.transform = "translateY(0)";
          element.style.opacity = 1;
        } else if (element.classList.contains("zoom-in")) {
          element.style.transition = "transform 1s ease, opacity 1s ease";
          element.style.transform = "scale(1)";
          element.style.opacity = 1;
        } else if (element.classList.contains("slide-up-slow")) {
          element.style.transition = "transform 2s ease, opacity 2s ease"; // Slow slide-up
          element.style.transform = "translateY(0)";
          element.style.opacity = 1;
        } else if (element.classList.contains("slide-left-to-right")) {
          element.style.transition = "transform 1s ease-out, opacity 1s ease-out";
          element.style.transform = "translateX(0)";
          element.style.opacity = 1;
        } else if (element.classList.contains("slide-right-to-left")) {
          element.style.transition = "transform 1s ease, opacity 1s ease";
          element.style.transform = "translateX(0)";
          element.style.opacity = 1;
        }
      }
    });
  }

  // Set initial styles for animations
  function setInitialStyles() {
    const fadeInElements = document.querySelectorAll(".fade-in");
    fadeInElements.forEach((element) => {
      element.style.opacity = 0;
    });

    const slideUpElements = document.querySelectorAll(".slide-up");
    slideUpElements.forEach((element) => {
      element.style.transform = "translateY(20px)";
      element.style.opacity = 0;
    });

    const zoomInElements = document.querySelectorAll(".zoom-in");
    zoomInElements.forEach((element) => {
      element.style.transform = "scale(0.8)";
      element.style.opacity = 0;
    });
    const slideUpSlowElements = document.querySelectorAll(".slide-up-slow");
    slideUpSlowElements.forEach((element) => {
      element.style.transform = "translateY(50px)";
      element.style.opacity = 0;
    });

    const slideLeftToRightElements = document.querySelectorAll('.slide-left-to-right');
        slideLeftToRightElements.forEach(element => {
            element.style.transform = 'translateX(-100px)';  // Slightly off-screen to the left
            element.style.opacity = 0;
        });

        const slideRightToLeftElements = document.querySelectorAll('.slide-right-to-left');
        slideRightToLeftElements.forEach(element => {
            element.style.transform = 'translateX(100px)';  // Slightly off-screen to the right
            element.style.opacity = 0;
        });
  }

  // Listen for scroll events and check for elements in the viewport
  window.addEventListener("scroll", checkAnimation);
  window.addEventListener("resize", checkAnimation);

  // Set initial styles and perform an initial check
  setInitialStyles();
  checkAnimation();
});
